module.exports = __webpack_public_path__ + "static/media/logo.661c5af2.svg";